import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersUsersPromocodesParams, GetVouchersUsersPromocodesResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVouchersUsersPromocodes = createAsyncThunk<
  GetVouchersUsersPromocodesResponse,
  GetVouchersUsersPromocodesParams
>(
  `vouchers/getVouchersUsersPromocodes`,
  async ({ userId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersUsersPromocodes({ userId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers users promocodes",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers users promocodes", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);